<template lang="html">


    <!-- Sidebar -->
    <div class="border-right" id="sidebar-wrapper">
      <div class="header-sidebar" slot="header">
          <img :src="basepath+'/unodc_logo.png'" alt="" width="200px" />
      </div>
      <div class="list-group list-group-flush">
         
         <router-link
          :to="{ path: '/dashboard/Trainer/trainerDashboard', query: { training:AssigntrainingCode  }}"
        class="list-group-item list-group-item-action">
            <i class="material-icons">ballot</i> Training Detail
          </router-link>
        
          <router-link :to="{ path: '/dashboard/Trainer/uploadTrainingMaterial', query: { training:AssigntrainingCode  }}" class="list-group-item list-group-item-action">
            <i class="material-icons">cloud_upload</i> Upload Training Material
          </router-link>
          <router-link :to="{ path: '/dashboard/Trainer/trainerFeedback', query: { training:AssigntrainingCode  }}" class="list-group-item list-group-item-action">
            <i class="material-icons">feedback</i> Feedback
          </router-link>
          
          <router-link :to="{ path: '/dashboard/Trainer/quickTraineeReg', query: { training:AssigntrainingCode  }}" class="list-group-item list-group-item-action">
              <i class="material-icons">pie_chart</i> Quick Participant Registration
          </router-link>
       </div>
    </div>
</template>

<script>
// import { bus } from "../../../main";
export default {
  data: () => ({
    isSidebar: false,
    active: true,
    AssigntrainingCode: "",
    basepath: localStorage.getItem("BASE_PATH")
  }),
  created() {
    this.AssigntrainingCode = this.$route.query.training;
    // bus.$on("sidebarStatus", data => {
    //   this.active = data;
    // });
  },
  methods: {
    // isSidebar() {
    //   bus.$emit("sidebarStatus", this.active);
    // }
  }
};
</script>
<style>
/* .list-group-item:hover {
  padding-left: 30px;
  transition: 0.5s ease;
} */
</style>

<style scoped>
/*!
 * Start Bootstrap - Simple Sidebar (https://startbootstrap.com/template-overviews/simple-sidebar)
 * Copyright 2013-2019 Start Bootstrap
 * Licensed under MIT (https://github.com/BlackrockDigital/startbootstrap-simple-sidebar/blob/master/LICENSE)
 */

body {
  overflow-x: hidden;
}

.material-icons {
  font-size: 20px !important;
  vertical-align: bottom;
}
#sidebar-wrapper {
  min-height: 100vh;
  margin-left: -15rem;
  -webkit-transition: margin 0.25s ease-out;
  -moz-transition: margin 0.25s ease-out;
  -o-transition: margin 0.25s ease-out;
  transition: margin 0.25s ease-out;
}

#sidebar-wrapper .sidebar-heading {
  padding: 0.875rem 1.25rem;
  font-size: 1.2rem;
}

#sidebar-wrapper .list-group {
  width: 15rem;
}

#page-content-wrapper {
  min-width: 100vw;
}

#wrapper.toggled #sidebar-wrapper {
  margin-left: 0;
}

@media (min-width: 768px) {
  #sidebar-wrapper {
    margin-left: 0;
  }

  #page-content-wrapper {
    min-width: 0;
    width: 100%;
  }

  #wrapper.toggled #sidebar-wrapper {
    margin-left: -15rem;
  }
}
/* scrollbar css starts */
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(7, 167, 225);
  border-radius: 50px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgba(7, 167, 225);
}
/* scrollbar css ends */
</style>